export default "__VITE_ASSET__9d2BzN_j__"